/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogPollResponse
 */
export interface LogPollResponse {
    /**
     * 
     * @type {number}
     * @memberof LogPollResponse
     */
    newFailures?: number;
    /**
     * 
     * @type {number}
     * @memberof LogPollResponse
     */
    newSucceeded?: number;
}

/**
 * Check if a given object implements the LogPollResponse interface.
 */
export function instanceOfLogPollResponse(value: object): value is LogPollResponse {
    return true;
}

export function LogPollResponseFromJSON(json: any): LogPollResponse {
    return LogPollResponseFromJSONTyped(json, false);
}

export function LogPollResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogPollResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'newFailures': json['newFailures'] == null ? undefined : json['newFailures'],
        'newSucceeded': json['newSucceeded'] == null ? undefined : json['newSucceeded'],
    };
}

export function LogPollResponseToJSON(json: any): LogPollResponse {
    return LogPollResponseToJSONTyped(json, false);
}

export function LogPollResponseToJSONTyped(value?: LogPollResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newFailures': value['newFailures'],
        'newSucceeded': value['newSucceeded'],
    };
}

